import { useState, useEffect, useRef } from 'react';
import apiClient from '../../Api/apiClient';

const BusinessCategorySelector = ({ onSelectCategory }) => {
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  // useEffect(() => {
  //   apiClient
  //     .get('/user/visitor/sector')
  //     .then(response => {
  //       console.log('Fetched sector:', response.data.data);
  //       setCategories(response.data.data);
  //       setFilteredCategories(response.data.data);
  //     })
  //     .catch(error => console.error('Error fetching categories:', error));
  // }, []);

useEffect(() => {
  apiClient
    .get('/user/visitor/sector')
    .then(response => {
      if (!response.data || !response.data.data) {
        // console.error('Invalid API response format:', response);
        return;
      }

      // Extract only valid and active sub-sectors
      const allSubSectors = response.data.data
        .filter(
          sector => sector.sub_sectors && Array.isArray(sector.sub_sectors)
        )
        .flatMap(sector => sector.sub_sectors) // Flatten sub-sectors
        .filter(subsector => subsector && subsector.status === 1); // Keep only active ones

      // console.log('Filtered Active Sub-Sectors:', allSubSectors);
      setCategories(allSubSectors); // Store only active sub-sectors
      setFilteredCategories(allSubSectors);
    })
    .catch(error => console.error('Error fetching sub-sectors:', error));
}, []);





  useEffect(() => {
    const handleClickOutside = event => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


const handleSearch = e => {
  const value = e.target.value;
  setSearchTerm(value);
  setHighlightedIndex(-1);

  if (value) {
    setFilteredCategories(
      categories.filter(subsector =>
        subsector.name.toLowerCase().includes(value.toLowerCase())
      )
    );
  } else {
    setFilteredCategories(categories);
  }
  setShowSuggestions(true);
};


const handleSelectCategory = subsector => {
  if (!subsector || !subsector.id) {
    console.error('Invalid sub-sector selection:', subsector);
    return;
  }

  setSelectedCategory(subsector);
  setSearchTerm(subsector.name);
  setShowSuggestions(false);

  // Pass only the selected sub-sector ID
  onSelectCategory(subsector.id);
};


  const handleKeyDown = e => {
    if (showSuggestions) {
      if (e.key === 'ArrowDown') {
        setHighlightedIndex(prev =>
          prev < filteredCategories.length - 1 ? prev + 1 : prev
        );
      } else if (e.key === 'ArrowUp') {
        setHighlightedIndex(prev => (prev > 0 ? prev - 1 : prev));
      } else if (e.key === 'Enter' && highlightedIndex !== -1) {
        handleSelectCategory(filteredCategories[highlightedIndex]);
      }
    }
  };

  return (
    <div className="flex flex-row md:flex-row md:items-center items-center md:gap-2 gap-1 text-xs relative mb-1 ">
      <label className=" w-1/3">Category</label>
      <div className="relative w-full ">
        <input
          ref={inputRef}
          type="text"
          className="w-full border border-gray-300 rounded-md py-2 px-3 text-xs"
          placeholder="Search Category"
          value={searchTerm}
          onChange={handleSearch}
          onFocus={() => setShowSuggestions(true)}
          onKeyDown={handleKeyDown}
        />
        {showSuggestions && filteredCategories.length > 0 && (
          <ul
            ref={dropdownRef}
            className="absolute z-10 w-full border bg-white mt-1 max-h-40 overflow-y-auto shadow-lg text-left text-xs"
          >
            {filteredCategories.map((sector, index) => (
              <li
                key={sector.id}
                className={`p-2 cursor-pointer ${
                  highlightedIndex === index
                    ? 'bg-gray-200'
                    : 'hover:bg-gray-300'
                }`}
                onMouseEnter={() => setHighlightedIndex(index)}
                onClick={() => handleSelectCategory(sector)}
              >
                {sector.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default BusinessCategorySelector;

// import { useState, useEffect } from 'react';
// import apiClient from '../../Api/apiClient';

// const BusinessCategorySelector = ({ onSelectCategory }) => {
//   const [categories, setCategories] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filteredCategories, setFilteredCategories] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState(null);

//   // Fetch categories and subcategories from API
//   useEffect(() => {
//     apiClient
//       .get('/user/visitor/sector')
//       .then(response => {
//         console.log('Fetched sector:', response.data.data);

//         // Store sectors and their sub-sectors
//         setCategories(response.data.data);
//       })
//       .catch(error => {
//         console.error('Error fetching categories:', error);
//       });
//   }, []);

//   // Handle category search
//   const handleSearch = e => {
//     const value = e.target.value;
//     setSearchTerm(value);

//     if (value) {
//       const filtered = categories.filter(sector =>
//         sector.name.toLowerCase().includes(value.toLowerCase())
//       );
//       setFilteredCategories(filtered);
//       setShowSuggestions(true);
//     } else {
//       setShowSuggestions(false);
//     }
//   };

//   // Handle category selection
//   const handleSelectCategory = sector => {
//     setSelectedCategory(sector);
//     setSearchTerm(sector.name);
//     setShowSuggestions(false);

//     // Pass the selected sector's id and sub-sectors (id and name)
//     onSelectCategory(
//       sector.sub_sectors.map(sub => ({ id: sub.id, name: sub.name }))
//     );
//   };

//   return (
//     <div className="flex flex-col md:flex-row md:items-center items-start md:gap-2 gap-1 text-xs relative">
//       <label className="md:w-1/2 w-full">Select your Business Category</label>
//       <div className="relative w-full md:w-4/6">
//         <input
//           type="text"
//           className="w-full border border-gray-300 rounded-md py-2 px-3"
//           placeholder="Search Category"
//           value={searchTerm}
//           onChange={handleSearch}
//           onFocus={() => setShowSuggestions(true)}
//         />
//         {showSuggestions && filteredCategories.length > 0 && (
//           <ul className="absolute z-10 w-full border bg-white mt-1 max-h-40 overflow-y-auto shadow-lg text-left">
//             {filteredCategories.map(sector => (
//               <li
//                 key={sector.id}
//                 className="p-2 cursor-pointer hover:bg-gray-300 font-bold"
//                 onClick={() => handleSelectCategory(sector)}
//               >
//                 {sector.name}
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>

//       {/* Display Sub-sectors when hovering on the input */}
//       {/* {selectedCategory && (
//         <div
//           className="absolute w-full mt-2 p-3 border rounded-md bg-white shadow-lg"
//           style={{ top: '100%' }}
//         >
//           <ul className="text-xs text-gray-700">
//             {selectedCategory.sub_sectors?.map(sub => (
//               <li key={sub.id}>- {sub.name}</li>
//             ))}
//           </ul>
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default BusinessCategorySelector;
